<footer id="main-footer">
    <div fxHide.lt-md>
        <mat-toolbar fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" class="mat-elevation-z10 footer">
            <div fxLayout="column" fxLayoutAlign="start center" fxFlex="25">
                <img class="footer-logo-lt-md" alt="Tribal" />
                <span i18n="@@copyright-logo" name="copyright-logo">
                    Copyright© Tribal Education Ltd {{(dateProvider$ | async)?.year}}
                </span>
            </div>
            <div fxLayoutGap="10px" fxFlex="50" fxLayoutAlign="center">
                <button i18n="@@web-contact-us" name="web-contact-us" [class.active-link]="url?.includes('contact-us')" (click)="redirectToContactUs()" mat-button>Contact us</button>
                <button i18n="@@web-accessibility" name="web-accessibility" [class.active-link]="url?.includes('accessibility')" (click)="redirectToAccessibility()"  mat-button>Accessibility</button>
                <button i18n="@@web-privacy" name="web-privacy" [class.active-link]="url?.includes('privacy-policy')" (click)="redirectToPrivacyPolicy()" mat-button>Privacy policy</button>
                <button i18n="@@web-copyright" name="web-copyright" [class.active-link]="url?.includes('copyright')" (click)="redirectToCopyright()" mat-button>Copyright</button>
                <a role="button" style="visibility: hidden;">Site Map</a>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" fxFlex="25">
                <img class="footer-logo" alt="European Social fund (ESF)">
            </div>
        </mat-toolbar>
    </div>

    <div fxHide.gt-sm>
        <mat-toolbar fxLayout="column" fxLayoutAlign="space-evenly center" class="mat-elevation-z10 footer bg-grey">
            <mat-list fxLayout="column">
                <button i18n="@@mobile-contact-us" name="mobile-contact-us" [class.active-link]="url?.includes('contact-us')" (click)="redirectToContactUs()" mat-button>Contact us</button>
                <button i18n="@@mobile-accessibility" name="mobile-accessibility" [class.active-link]="url?.includes('accessibility')" (click)="redirectToAccessibility()" mat-button>Accessibility</button>
                <button i18n="@@mobile-privacy" name="mobile-privacy" [class.active-link]="url?.includes('privacy-policy')" (click)="redirectToPrivacyPolicy()"  mat-button>Privacy policy</button>
                <button i18n="@@mobile-copyright" name="mobile-copyright" [class.active-link]="url?.includes('copyright')" (click)="redirectToCopyright()" mat-button>Copyright</button>
                <a role="button" style="visibility: hidden;">Site Map</a>

                <mat-divider></mat-divider>

                <div fxLayout="column" fxLayoutAlign="space-evenly center">
                    <img class="footer-logo-sm" alt="Tribal" />
                    <span i18n="@@copyright-logo" name="copyright-logo">
                        Copyright© Tribal Education Ltd {{(dateProvider$ | async)?.year}}
                    </span>
                    <br />
                </div>
            </mat-list>
        </mat-toolbar>
    </div>
</footer>
